import React, { useEffect, useState } from "react";
import { Badge, Button } from "react-bootstrap";
import Posts from "./Components/HospitalMarketing/Posts";
import ChatWithDesigner from "./Components/HospitalMarketing/ChatWithDesigner";
import SelectFrame from "./Components/HospitalMarketing/SelectFrame";
import { getuserdata } from "../services/apiService";
import EmailVerify from "../layouts/Doctor/Components/Dashbord/EmailVerify";

const HospitalMarketing = () => {
    const [userdata, setUserdata] = useState({});
    const [tabsest, setTabseset] = useState("Posts");
    const [analytics, setAnalytics] = useState({
        facebook: {
            trend: 'up',
            percentage: 15,
            color: '#4CAF50',
            label: 'Facebook'
        },
        instagram: {
            trend: 'down',
            percentage: -8,
            color: '#F44336',
            label: 'Instagram'
        },
        twitter: {
            trend: 'up',
            percentage: 12,
            color: '#4CAF50',
            label: 'Twitter'
        },
        linkedin: {
            trend: 'up',
            percentage: 5,
            color: '#4CAF50',
            label: 'LinkedIn'
        }
    });

    useEffect(() => {
        getUserData();
        const urlParams = new URLSearchParams(window.location.search);
        const tab = urlParams.get('tab');
        if (tab) {
            setTabseset(tab);
        }
    }, []);

    const handleTabs = (tab) => {
        window.history.pushState({}, '', `?tab=${tab}`);
        setTabseset(tab);
    };

    const getUserData = async () => {
        const userData = await getuserdata('full');
        setUserdata(userData);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                {userdata.activation_key == null && (
                    <EmailVerify />
                )}

                {/* Header Card */}
                <div className="card mb-4">
                    <div className="card-body">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                                <h5 className="mb-0 font-weight-bold">Marketing & Social Media</h5>
                                <Badge bg="info">Analytics</Badge>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main Content with Sidebar */}
                <div className="row">
                    {/* Left Sidebar - Tabs */}
                    <div className="col-12 col-lg-2 mb-3">
                        <div className="card">
                            <div className="card-body" style={{ padding: '15px' }}>
                                <div className="d-flex flex-column" style={{ gap: '8px' }}>
                                    <button
                                        onClick={() => handleTabs("Posts")}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            borderLeft: tabsest === "Posts" ? '4px solid var(--themecolor)' : '4px solid transparent',
                                            color: tabsest === "Posts" ? 'var(--themecolor)' : '#666',
                                            fontWeight: tabsest === "Posts" ? '700' : '600',
                                            fontSize: '14px',
                                            padding: '12px 15px',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (tabsest !== "Posts") {
                                                e.currentTarget.style.borderLeft = '4px solid #e0e0e0';
                                                e.currentTarget.style.color = '#333';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (tabsest !== "Posts") {
                                                e.currentTarget.style.borderLeft = '4px solid transparent';
                                                e.currentTarget.style.color = '#666';
                                            }
                                        }}
                                    >
                                        Posts
                                    </button>
                                    <button
                                        onClick={() => handleTabs("Chat With Designer")}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            borderLeft: tabsest === "Chat With Designer" ? '4px solid var(--themecolor)' : '4px solid transparent',
                                            color: tabsest === "Chat With Designer" ? 'var(--themecolor)' : '#666',
                                            fontWeight: tabsest === "Chat With Designer" ? '700' : '600',
                                            fontSize: '14px',
                                            padding: '12px 15px',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (tabsest !== "Chat With Designer") {
                                                e.currentTarget.style.borderLeft = '4px solid #e0e0e0';
                                                e.currentTarget.style.color = '#333';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (tabsest !== "Chat With Designer") {
                                                e.currentTarget.style.borderLeft = '4px solid transparent';
                                                e.currentTarget.style.color = '#666';
                                            }
                                        }}
                                    >
                                        Chat With Designer
                                    </button>
                                    <button
                                        onClick={() => handleTabs("Select Frame")}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            borderLeft: tabsest === "Select Frame" ? '4px solid var(--themecolor)' : '4px solid transparent',
                                            color: tabsest === "Select Frame" ? 'var(--themecolor)' : '#666',
                                            fontWeight: tabsest === "Select Frame" ? '700' : '600',
                                            fontSize: '14px',
                                            padding: '12px 15px',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (tabsest !== "Select Frame") {
                                                e.currentTarget.style.borderLeft = '4px solid #e0e0e0';
                                                e.currentTarget.style.color = '#333';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (tabsest !== "Select Frame") {
                                                e.currentTarget.style.borderLeft = '4px solid transparent';
                                                e.currentTarget.style.color = '#666';
                                            }
                                        }}
                                    >
                                        Select Frame
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content Area */}
                    <div className={`col-12 ${tabsest === "Select Frame" ? 'col-lg-10' : 'col-lg-7'}`}>
                        {tabsest === "Chat With Designer" && (
                            <ChatWithDesigner userdata={userdata} />
                        )}

                        {tabsest === "Select Frame" && (
                            <SelectFrame />
                        )}

                        {tabsest === "Posts" && (
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-4">
                                        <h5 className="mb-0 font-weight-bold">Social Media Analytics</h5>
                                        <Badge bg="success">Live Data</Badge>
                                    </div>

                                    {/* Analytics Cards Grid */}
                                    <div className="row">
                                        {Object.entries(analytics).map(([platform, data]) => (
                                            <div key={platform} className="col-12 col-md-6 mb-3">
                                                <div className="card" style={{
                                                    border: '1px solid #e8e8e8',
                                                    borderRadius: '8px',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                                    transition: 'all 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = 'translateY(-3px)';
                                                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = 'translateY(0)';
                                                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
                                                    }}>
                                                    <div className="card-body">
                                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                                            <div>
                                                                <h6 className="mb-1 font-weight-bold" style={{ fontSize: '18px' }}>
                                                                    {data.label}
                                                                </h6>
                                                                <small className="text-muted">Engagement Rate</small>
                                                            </div>
                                                            <div className="text-end">
                                                                <div style={{
                                                                    fontSize: '24px',
                                                                    fontWeight: '700',
                                                                    color: data.color,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '5px'
                                                                }}>
                                                                    <span>{data.percentage > 0 ? '+' : ''}{data.percentage}%</span>
                                                                    <i className={`fa fa-arrow-${data.trend === 'up' ? 'up' : 'down'}`}
                                                                        style={{ fontSize: '18px' }}></i>
                                                                </div>
                                                                <small className="text-muted">vs last month</small>
                                                            </div>
                                                        </div>

                                                        {/* Progress Bar */}
                                                        <div style={{
                                                            height: '8px',
                                                            backgroundColor: '#f0f0f0',
                                                            borderRadius: '4px',
                                                            overflow: 'hidden'
                                                        }}>
                                                            <div style={{
                                                                width: `${Math.min(Math.abs(data.percentage) * 5, 100)}%`,
                                                                height: '100%',
                                                                backgroundColor: data.color,
                                                                borderRadius: '4px',
                                                                transition: 'width 0.5s ease'
                                                            }}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Right Sidebar - Posts */}
                    {tabsest === "Posts" && (
                        <div className="col-12 col-lg-3">
                            <Posts />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HospitalMarketing;
